export default "__VITE_ASSET__D3YgQt27__"